/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { isNone, isEmpty } from '@ember/utils';

import COLOR_LABELS from 'cio/utils/color-labels';
import { DropdownMessage } from 'cio/utils/conditions/action-grouping';

interface EmailSelectSelectedItemArgs {
  option: DropdownMessage;
}

export default class EmailSelectSelectedItem extends Component<EmailSelectSelectedItemArgs> {
  get parentName() {
    if (this.args.option.isAnyInParent) {
      // The parent name option is a string that says "in Campaign Name", but
      // for visual purposes we want to make everything but the "in" bold. We
      // strip out that string so that we can add it again in the template, but
      // without being bold
      return this.args.option.parent?.name.replace('in ', '');
    }

    return null;
  }

  get variationLabel() {
    let variation = this.args.option?.variation;

    if (isNone(variation)) {
      return;
    }

    return COLOR_LABELS[variation - 1];
  }

  get languageLabel() {
    let itemLanguageCode = this.args.option?.language;

    if (isNone(itemLanguageCode)) {
      return;
    }

    return isEmpty(itemLanguageCode) ? 'Default' : itemLanguageCode;
  }
}
